var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
var NestedMenu = function (_a) {
    var nestedSubmenu = _a.nestedSubmenu, handleSegmentEvents = _a.handleSegmentEvents;
    var handleNavClick = function (text, link, isTargetBlank, handleClick) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!handleClick) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleClick()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!handleSegmentEvents) return [3 /*break*/, 4];
                    return [4 /*yield*/, handleSegmentEvents(text)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    window.open(link, isTargetBlank ? '_blank' : '_self');
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "lfc-absolute lfc-right-[-216px] lfc-top-[-10px] lfc-bg-white lfc-min-w-[216px] lfc-py-3 lfc-shadow-md lfc-rounded-lg" }, nestedSubmenu.map(function (_a, index) {
        var link = _a.link, text = _a.text, isTargetBlank = _a.isTargetBlank, handleClick = _a.handleClick;
        return (React.createElement("button", { key: index, 
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, handleNavClick(text, link, isTargetBlank, handleClick)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }, className: "lfc-flex lfc-flex-col lfc-gap-2 lfc-px-4 lfc-py-3 hover:lfc-bg-[#443EFF] lfc-text-black hover:lfc-text-white lfc-transition lfc-w-full" },
            React.createElement("p", { className: "lfc-text-sm " }, text)));
    })));
};
export default NestedMenu;
//# sourceMappingURL=NestedMenu.js.map